import { Injectable } from '@angular/core';
import { uniqBy, includes } from 'lodash';

@Injectable()
export class ImageFilteringService {
  public filter(items) {
      return uniqBy(items, (item: any) => {
        if (!item.deduplicates) {
          return `${item.file.name}_${item.file.size}`;
        } else {
          return `${item.selectedPicture.file.name}_${item.selectedPicture.file.size}`;
        }
      }).filter((item: any) => {
        if (!item.deduplicates) {
          return includes(item.file.type, 'image/');
        } else {
          return includes(item.selectedPicture.type, 'image/');
        }
      });
  }
}
